import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type AuthState = {
  isAuthenticated: boolean;
  platform: number | null;
  isAuthModalVisible: boolean;
};

const initialAppState: AuthState = {
  isAuthenticated: false,
  platform: null,
  isAuthModalVisible: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialAppState,
  reducers: {
    setIsAuthenticatedAction: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setPlatformAction: (state, action: PayloadAction<number>) => {
      state.platform = action.payload;
    },
    setIsAuthModalVisibleAction: (state, action: PayloadAction<boolean>) => {
      state.isAuthModalVisible = action.payload;
    },
  },
});

const authBaseSelector = createBaseSelector(authSlice);

registerSlice([authSlice]);

export const authStore = {
  actions: authSlice.actions,
  selectors: {
    isAuthenticated: createSelector(authBaseSelector, (s) => s.isAuthenticated),
    platform: createSelector(authBaseSelector, (s) => s.platform),
    isAuthModalVisible: createSelector(authBaseSelector, (s) => s.isAuthModalVisible),
  },
};
